module.exports = __webpack_public_path__ + "img/dawn.b56316d2.jpg";